var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valueItem),expression:"valueItem"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.valueItem)},on:{"input":function($event){if($event.target.composing)return;_vm.valueItem=$event.target.value}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }